import { render, staticRenderFns } from "./CanteenSignal.vue?vue&type=template&id=2f1e8bb0"
import script from "./CanteenSignal.vue?vue&type=script&lang=js"
export * from "./CanteenSignal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports